// extracted by mini-css-extract-plugin
var _1 = "SearchManagePlatformButton-module__animatedBackground--uA6iL";
var _2 = "SearchManagePlatformButton-module__buttonWrapper--i6nVm";
var _3 = "SearchManagePlatformButton-module__settingsSectionTitle--emWnp";
export { _1 as "animatedBackground", _2 as "buttonWrapper", _3 as "settingsSectionTitle" }
